import { GetUploadImageInfoResponse } from "./api-services/get-upload-image-info.service";
import { KYMW1709Component } from "./kymw1709.component";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";

/**
 * アップロード画像確認画面の値を管理するクラス
 * 
 */
export class KYMW1709Model {
  kymw1709Component: KYMW1709Component;
  
  /** 親画面から受け取った値 */
  imageFileName: string = <string>'';

  imageFile1: string = <string>'';      // 画像ファイル1 Base64コード
  imageFileName1: string = <string>'';  // 画像ファイル名1 
  imagePixel1: string = <string>'';     // 画像ピクセル数1 
  imageFile2: string = <string>'';      // 画像ファイル2 Base64コード
  imageFileName2: string = <string>'';  // 画像ファイル名2
  imagePixel2: string = <string>'';     // 画像ピクセル数2
  imageFile3: string = <string>'';      // 画像ファイル3 Base64コード 
  imageFileName3: string = <string>'';  // 画像ファイル名3
  imagePixel3: string = <string>'';     // 画像ピクセル数3

  // 画像URLの拡張子
  imageFileMIME1: string = <string>'';  // 画像ファイル1 拡張子
  imageFileMIME2: string = <string>'';  // 画像ファイル2 拡張子
  imageFileMIME3: string = <string>'';  // 画像ファイル3 拡張子

  /**
   * レスポンスデータを画像表示用に設定
   * @param data 
   */
  setImageFileName(data: GetUploadImageInfoResponse) {
    if (data) {
      this.imageFile1 = data.ImageFile1;
      this.imageFileName1 = data.ImageFileName1;
      this.imagePixel1 = data.ImagePixel1;
     
      // 2,3件目の画像は存在しない場合非表示
      this.imageFile2 = data.ImageFile2;
      this.imageFileName2 = data.ImageFileName2;
      this.imagePixel2 = data.ImagePixel2;
      this.imageFile3 = data.ImageFile3;
      this.imageFileName3 = data.ImageFileName3;
      this.imagePixel3 = data.ImagePixel3;

      // 画像ファイル名の拡張子から、画像URLの拡張子を設定
      this.imageFileMIME1 = PlessViewUtilsSub.getExtension(this.imageFileName1);
      this.imageFileMIME2 = PlessViewUtilsSub.getExtension(this.imageFileName2);
      this.imageFileMIME3 = PlessViewUtilsSub.getExtension(this.imageFileName3);
    }
  }

}